// 应用插件总线
export const ele = require('./ele/').default
// export const ansoUi = require('./ansoUi/').default
